import { TranslateService } from '@ngx-translate/core';
import { Configuration } from './../../../conf/app.constants';
import { ProfileService } from './../../../../services/profile.services';
import { ServiceLocator } from './../../../ServiceLocator';
import { Component, AfterViewInit, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from '../../../store/AppState';
import { of, Subscription, Observable, forkJoin } from 'rxjs';
import { AuthService } from '../../../auth.service';
import { TaskDTO } from '../../../api/plyca-dtos';
import { UserService } from '../../../user.service';
import { TaskService } from '../../../tasks/task.service';
import { AppComponent } from '../../../app.component';
import { HelpService } from '../help/help.service';
import { AppConfiguration } from '../../../conf/app.configuration';
import { PlycaDataService } from '../../../../services/plyca.service';
import { InitService } from '../../../../services/init.service';
import { BaseComponent } from '../baseComponent/base.component';
import { HelpElementDTO } from '../help/help.dtos';
import {
  userDetailComponent,
  UserDetailDTOModal,
} from '../../../user/userDetail/userDetail.component';
import { DynamicDialogConfig, DialogService } from 'primeng-lts/dynamicdialog';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { WaitLoadingService } from '../waitLoading/wait-loading.service';

declare var jQuery: any;

@Component({
  selector: 'navigation',
  templateUrl: 'navigation.template.html',
  providers: [DialogService],
})
export class NavigationComponent
  extends BaseComponent
  implements AfterViewInit, OnInit, OnDestroy {
  // Referencia a la lista de tareas almacenada en el store
  subscription: Subscription;
  numTareas: string;

  userFullName: string;

  loading: boolean;

  modeView: string;

  newContractEnabled = true;
  newOrderProjectEnabled = false;
  newBudgetaryProjectEnabled = false;
  documentSearchEnabled = false;
  calendarEnabled = true;
  profileService: any;
  adaptationCixtecEnabled = false;
  adaptationCixtecIntegrationBitacoraEnabled = false;
  adaptationAymadEnabled = false;
  infrastructurePlanEnabled = false;
  spendingProjectEnabled = false;
  helpElements = [];
  showModal = false;

  constructor(
    public authService: AuthService,
    private router: Router,
    private store: Store<AppState>,
    private taskService: TaskService,
    public userService: UserService,
    private appComponent: AppComponent,
    protected helpService: HelpService,
    protected plycaService: PlycaDataService,
    public appConfig: AppConfiguration,
    protected initService: InitService,
    private configuration: Configuration,
    private translateService: TranslateService,
    private dialogService: DialogService,
    private _http: HttpClient,
    private waitService: WaitLoadingService
  ) {
    super();
    this.profileService = ServiceLocator.injector.get(ProfileService);
    this.subscribe(this.appComponent.modeViewObservable, (mode) => {
      this.modeView = mode;
    });
    this.calendarEnabled = true;
    if (this.appConfig.getValue('calendar.enabled.profiles') !== undefined
      && !this.userService.hasRoles(this.appConfig.getValue('calendar.enabled.profiles'))) {
      this.calendarEnabled = false;
    }
    this.documentSearchEnabled = true;
    if (appConfig.getValue('documentSearch.enabled') !== undefined) {
      this.documentSearchEnabled = appConfig.getValue('documentSearch.enabled');
    }
    let _searchProfiles = this.appConfig.getValue('documentSearch.profiles');
    if (_searchProfiles !== undefined) {
      this.documentSearchEnabled =
        this.documentSearchEnabled &&
        this.userService.hasRoles(_searchProfiles);
    }

    this.newContractEnabled = appConfig.getValue('newcontract.enabled');
    let _profiles = this.appConfig.getValue('newcontract.defaultProfiles');
    if (_profiles) {
      this.newContractEnabled =
        this.newContractEnabled && this.userService.hasRoles(_profiles);
    }

    this.newOrderProjectEnabled = appConfig.getValue(
      'newOrderProjectEnabled.enabled'
    );
    let _profilesOrderProject = this.appConfig.getValue(
      'newOrderProject.defaultProfiles'
    );
    if (_profilesOrderProject) {
      this.newOrderProjectEnabled =
        this.newOrderProjectEnabled &&
        this.userService.hasRoles(_profilesOrderProject);
    }

    // Plan de infraestructuras
    let _profilesViewInfrastructurePlan = this.appConfig.getValue(
      'infrastructurePlan.view.profiles'
    );
    let _profilesEditInfrastructurePlan = this.appConfig.getValue(
      'infrastructurePlan.edition.profiles'
    );
    if (_profilesViewInfrastructurePlan) {
      this.infrastructurePlanEnabled =
        this.userService.hasRoles(_profilesViewInfrastructurePlan);
    }
    if (!this.infrastructurePlanEnabled && _profilesEditInfrastructurePlan) {
      this.infrastructurePlanEnabled =
        this.userService.hasRoles(_profilesEditInfrastructurePlan);
    }

    // Projecto de gastos
    let _profilesViewSpendingProject = this.appConfig.getValue(
      'spendingProject.view.profiles'
    );
    let _profilesEditSpendingProject = this.appConfig.getValue(
      'spendingProject.edition.profiles'
    );
    if (_profilesViewSpendingProject) {
      this.spendingProjectEnabled =
        this.userService.hasRoles(_profilesViewSpendingProject);
    }
    if (!this.spendingProjectEnabled && _profilesEditSpendingProject) {
      this.spendingProjectEnabled =
        this.userService.hasRoles(_profilesEditSpendingProject);
    }

    // Accesos a adaptaciones de CIXTEC
    this.adaptationCixtecEnabled = appConfig.getValue('cliente') === 'CIXTEC';
    console.log('this.adaptationCixtecEnabled', this.adaptationCixtecEnabled);
    if (this.adaptationCixtecEnabled) {
      // Integración con Bitácora
      let user = userService.getUser();

      // Si es el organismo es entidad verificamos si tiene acceso mediante los datos del propio organismo
      let organizationalUnit = user?.organizationalUnit;
      console.log('organizationalUnit', organizationalUnit);
      if (organizationalUnit != null && organizationalUnit.entity === true) {
        console.log(
          'el organismo es entidad, verificamos la configuración de acceso mediante los datos del propio organismo'
        );
        let datas = organizationalUnit['data'];
        if (datas != null) {
          datas = datas.filter(
            (item) =>
              item?.name ===
              'Adaptation.Cixtec.Integration.Bitacora.EnabledByEntity'
          );
          if (datas != null && datas.length > 0) {
            let dataValue = datas[0]?.value;
            if (dataValue == '1') {
              this.adaptationCixtecIntegrationBitacoraEnabled = true;
            }
          }
        }
      } else {
        // Si el organismo no es entidad, verificamos si tiene acceso mediante la entidad a la que pertenece
        console.log(
          'el organismo no es entidad, verificamos la configuración de acceso mediante datos de la entidad a la que pertenece'
        );
        let entity = user?.organizationalUnit?.entityDTO;
        if (entity != null) {
          let datas = entity['data'];
          if (datas != null) {
            datas = datas.filter(
              (item) =>
                item?.name ===
                'Adaptation.Cixtec.Integration.Bitacora.EnabledByEntity'
            );
            if (datas != null && datas.length > 0) {
              let dataValue = datas[0]?.value;
              if (dataValue == '1') {
                this.adaptationCixtecIntegrationBitacoraEnabled = true;
              }
            }
          }
        }
      }
    }
    console.log(
      'this.adaptationCixtecIntegrationBitacoraEnabled',
      this.adaptationCixtecIntegrationBitacoraEnabled
    );

    this.adaptationAymadEnabled = appConfig.getValue('cliente') === 'AYMAD';

    this.newBudgetaryProjectEnabled = appConfig.getValue(
      'newBudgetaryProjectEnabled.enabled'
    );
    let _profilesBudgetaryProject = this.appConfig.getValue(
      'newBudgetaryProject.defaultProfiles'
    );
    if (_profilesBudgetaryProject) {
      this.newBudgetaryProjectEnabled =
        this.newBudgetaryProjectEnabled &&
        this.userService.hasRoles(_profilesBudgetaryProject);
    }
  }

  ngOnInit(): void {
    this.initService.init();
    this.subscribe(
      this.store.select('pendingTasks'),
      (tasks: Array<TaskDTO>) => {
        if (tasks && tasks.length) {
          this.numTareas = '' + tasks.length;
        } else {
          this.numTareas = undefined;
        }
      }
    );
    this.subscribe(this.taskService.loadingStatusObservable, (x) => {
      this.loading = x;
    });

  }

  setGuiasUso(): Observable<any> {
    // Array para almacenar todos los observables
    const observables = [];

    // Verificar si helpElements esta vacio
    if (this.helpElements.length === 0) {
      this.waitService.startWaiting();
      // Observables para cada solicitud de ayuda
      const guia1Observable = this.plycaService
        .get<HelpElementDTO>(this.configuration.HELP_ELEMENT_SERVICE_URL, 'GUIA_USO_0001')
        .pipe(
          tap((help: HelpElementDTO) => {
            if (help) {
              help.content = null;
              this.helpElements.push(help);
            } else {
              console.log('NO ENCONTRADA ELEMENTO DE AYUDA CON ID: ' + 'GUIA_USO_0001');
            }
          }),
          catchError((err) => {
            console.log(err);
            return of(true);
          })
        );

      observables.push(guia1Observable);

      // Condiciones adicionales para solicitudes de ayuda adicionales
      if (this.userService.hasModulesAccess(['ESTANDAR','ESTANDAR-LICITA','ESTANDAR-LITE']) && this.userService.hasRolesInApp('CONTRATACION')) {
        const guiaObservable = this.plycaService
          .get<HelpElementDTO>(this.configuration.HELP_ELEMENT_SERVICE_URL, 'GUIA_USO_0001_CONTRATACION')
          .pipe(
            tap((help: HelpElementDTO) => {
              if (help) {
                help.content = null;
                this.helpElements.push(help);
              } else {
                console.log('NO ENCONTRADA ELEMENTO DE AYUDA CON ID: ' + 'GUIA_USO_0001_CONTRATACION');
              }
            }),
            catchError((err) => {
              console.log(err);
              return of(true);
            })
          );
        observables.push(guiaObservable);
      }

      if (this.userService.hasModulesAccess(['REGCON']) && this.userService.hasRolesInApp('RECO')) {
        const guiaObservable = this.plycaService
          .get<HelpElementDTO>(this.configuration.HELP_ELEMENT_SERVICE_URL, 'GUIA_USO_0001_RECO')
          .pipe(
            tap((help: HelpElementDTO) => {
              if (help) {
                help.content = null;
                this.helpElements.push(help);
              } else {
                console.log('NO ENCONTRADA ELEMENTO DE AYUDA CON ID: ' + 'GUIA_USO_0001_RECO');
              }
            }),
            catchError((err) => {
              console.log(err);
              return of(true);
            })
          );
          observables.push(guiaObservable);
        }
    
      if (this.userService.hasModulesAccess(['PLANIF-CONTR']) && this.userService.hasRolesInApp('CONTRATACION')) {
        const guiaObservable = this.plycaService
          .get<HelpElementDTO>(this.configuration.HELP_ELEMENT_SERVICE_URL, 'GUIA_USO_0001_PLANIF-CONTR')
          .pipe(
            tap((help: HelpElementDTO) => {
              if (help) {
                help.content = null;
                this.helpElements.push(help);
              } else {
                console.log('NO ENCONTRADA ELEMENTO DE AYUDA CON ID: ' + 'GUIA_USO_0001_PLANIF-CONTR');
              }
            }),
            catchError((err) => {
              console.log(err);
              return of(true);
            })
          );
        observables.push(guiaObservable);
      }
      return forkJoin(observables).pipe(
        tap(() => {
          this.waitService.cancelWaiting();
          console.log('Todas las solicitudes de guias de ayuda se han completado.');
        })
      );
    } else
      return of(null);
  }

  ngOnDestroy() {
    this.appComponent = null;
    super.ngOnDestroy();
  }

  ngAfterViewInit() {
    jQuery('#side-menu').metisMenu();

    //establecemos el logo de la entidad
    let user = this.userService.getUser();
    if (user && user.organizationalUnit && user.organizationalUnit.identifier) {
      var url_default =
        this.appConfig.getValue('resources.url') + '/logos/LOGO_DEFAULT';
      var url =
        this.appConfig.getValue('resources.url') +
        '/logos/LOGO_' +
        user.organizationalUnit.identifier;
      //Si existe el logo por organismo cambiamos el estilo del logo
      this._http
        .get(url, {
          headers: new HttpHeaders({
            Accept: '*/*',
          }),
          responseType: 'blob',
        })
        .subscribe(
          (response) => {
            document.documentElement.style.setProperty(
              '--bg-img-org',
              'url(' + url + ')'
            );
          },
          (error) => {
            console.log('No hay configurado logo para la entidad en ' + url);
            //Si no existe el logo por organismo buscamos el logo por defecto
            this._http
              .get(url_default, {
                headers: new HttpHeaders({
                  Accept: '*/*',
                }),
                responseType: 'blob',
              })
              .subscribe(
                (response) => {
                  document.documentElement.style.setProperty(
                    '--bg-img-org',
                    'url(' + url_default + ')'
                  );
                },
                (error) => {
                  //Si no existe logo por defecto dejamos el del estilo del cliente
                  console.log(
                    'No hay configurado logo por defecto en ' + url_default
                  );
                }
              );
          }
        );
    }
  }

  activeRoute(routename: string): boolean {
    return this.router.url.endsWith(routename);
  }

  miniNavControl(): void {
    if (jQuery('body').hasClass('body-small')) {
      jQuery('body').toggleClass('mini-navbar');
    }
  }

  showGeneralGuide(element = '') {
    this.subscribe(this.setGuiasUso(),(x)=>{
      if (element?.['identifier']) {
        this.showModal = false;
        this.helpService.showHelpElementInDialog(element['identifier']);
      }else if (element != '') {
        this.showModal = false;
        this.helpService.showHelpElementInDialog(element);
      } else {
        if (this.helpElements.length == 1) {
          this.showModal = false;
          this.helpService.showHelpElementInDialog(this.helpElements[0].identifier);
        } else {
          this.showModal = true;
        }
      }
  });
  }

  viewUserDetail() {
    let user = this.userService.getUser();
    let context = new UserDetailDTOModal(user);
    let config: DynamicDialogConfig = {
      header: this.translateService.instant('UserDetail.detail'),
      width: '85%',
      style: { overflow: 'scroll', 'max-height': '80%' },
    };

    config['context'] = new UserDetailDTOModal(user);
    const ref = this.dialogService.open(userDetailComponent, config);
    this.subscribe(ref.onClose);
  }

  logout() {
    this.authService.logout();
  }
}
